import { FC } from 'react';
import { Vehicle } from 'further-types/lp/vehicle';
import { VehicleApplication } from '../types';
import CommitmentPreview from './CommitmentPreview';
import CommitmentSettings from './CommitmentSettings';
import ErrorBoundary from 'components/ErrorBoundary';

type Props = {
  title?: string;
  application: VehicleApplication;
  vehicle: Vehicle;
  commitmentFormVisible: boolean;
  onShowCommitmentForm: () => void;
  onHideCommitmentForm: () => void;
  isInvestorJourneyForm?: boolean;
};

const CommitmentDetails: FC<Props> = ({
  title = 'Commitment details',
  application,
  vehicle,
  commitmentFormVisible,
  onShowCommitmentForm,
  onHideCommitmentForm,
  isInvestorJourneyForm = false,
}) => {
  const applicationCompleted = !!application.commitment;

  return (
    <ErrorBoundary>
      {applicationCompleted && !commitmentFormVisible ? (
        <CommitmentPreview
          title={title}
          application={application}
          vehicle={vehicle}
          onShowCommitmentForm={onShowCommitmentForm}
        />
      ) : application.commitmentSettings.isManuallyAddedCommitment ||
        isInvestorJourneyForm ||
        commitmentFormVisible ? (
        <CommitmentSettings
          title={title}
          application={application}
          vehicle={vehicle}
          onHideCommitmentForm={onHideCommitmentForm}
          fullWidth={isInvestorJourneyForm}
        />
      ) : null}
    </ErrorBoundary>
  );
};

export default CommitmentDetails;
